module.exports = __webpack_public_path__ + "img/03jigou.dbf12016.png";